export const getLabelTypes = (t) => [
  { value: 'users', label: 'User Labels' },
  { value: 'equipment', label: 'Equipment Labels' },
  { value: 'projectGanttSchedule', label: 'Gantt Labels' },
  { value: 'invoices', label: 'Invoice Status Labels' },
  { value: 'customers', label: `${t('Customer')} Labels` },
  { value: 'vendors', label: 'Vendor Labels' },
  { value: 'projects', label: 'Project Labels' },
];

export const STATUS_TYPES = [
  { value: 'equipment', label: 'Equipment Statuses' },
];

export const getStatusTypes = (bucketTemplates) => {
  const baseStatusTypes = STATUS_TYPES;
  const bucketTemplateStatusTypes = bucketTemplates.map((bucketTemplate) => ({
    value: bucketTemplate.id,
    label: `${bucketTemplate.name} Statuses`,
  }));
  return [...baseStatusTypes, ...bucketTemplateStatusTypes];
};
